import React from 'react';

function SalesTeams() {
  return (
    <div>
        Welcome to SalesTeams Component.
    </div>
  );
}

export default SalesTeams;
